"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.latestBadLink = exports.markLinkAsClear = exports.destroyUrl = exports.createOrUpdateLink = exports.findOrCreateLink = exports.updateLink = exports.createLink = exports.badLinkInfoList = exports.findByUrl = exports.BAD_WEBPURIFY_STATUSES = exports.LINK_DETECTION_FIRESTORE_COLLECTION_NAME = void 0; // @file Store nsfw detection results on Google Firestore - currently backed by Resource Store
// Currently it's only webpurify but we may add Google's Content Safety API and other stuffs later on

var configure_1 = require("./configure");

var resource_store_1 = require("./resource_store"); // must match the value used in rails


var LINK_DETECTION_FIRESTORE_COLLECTION_NAME = 'link:detection:v1';
exports.LINK_DETECTION_FIRESTORE_COLLECTION_NAME = LINK_DETECTION_FIRESTORE_COLLECTION_NAME; // We have custom status code from webpurify:
// Reference: https://app.frontapp.com/open/cnv_ayvbjnz
// For images:
//   -3 - CSAM
//   -1 - Blank or Broken
//    1 - Accept
//    2 - Nudity and Sex
//    3 - Hate or Hate Crimes
//    4 - Violence
//    5 - Offensive Gestures or Language
//    6 - Drugs,Drug Paraphernalia, or drug use
// For videos:
//   -3 - CSAM
//   -1 - Blank or Broken
//   1 - approved
//   2 - declined
//   3 - video file was not found
//   4 - video format not supported
//   5 - video length longer than time in account, please refill your license
//   6 - video broken or not viewable
//   7 - video contains a language other than English

var BAD_WEBPURIFY_STATUSES = ['-3', '2'];
exports.BAD_WEBPURIFY_STATUSES = BAD_WEBPURIFY_STATUSES;

function findByUrl(url) {
  return (0, resource_store_1.findById)(LINK_DETECTION_FIRESTORE_COLLECTION_NAME, url);
}

exports.findByUrl = findByUrl;
var badLinkQueries = [{
  field: 'webpurifyStatus',
  operand: 'in',
  value: BAD_WEBPURIFY_STATUSES
}, {
  field: 'isCleared',
  operand: '==',
  value: false
}];

function badLinkInfoList(_a) {
  var _b = _a === void 0 ? {
    additionalQueries: []
  } : _a,
      limit = _b.limit,
      pageLimit = _b.pageLimit,
      startAfter = _b.startAfter,
      additionalQueries = _b.additionalQueries; // bad webpurify status and we don't mark them as clear


  var queries = badLinkQueries.concat(additionalQueries);
  return (0, resource_store_1.findBy)({
    collectionName: LINK_DETECTION_FIRESTORE_COLLECTION_NAME,
    queries: queries,
    hardLimit: limit,
    pageLimit: pageLimit,
    startAfter: startAfter
  });
}

exports.badLinkInfoList = badLinkInfoList;

function createLink(linkInfo) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , (0, resource_store_1.create)(LINK_DETECTION_FIRESTORE_COLLECTION_NAME, linkInfo)];
    });
  });
}

exports.createLink = createLink;

function updateLink(linkInfo) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , (0, resource_store_1.update)(LINK_DETECTION_FIRESTORE_COLLECTION_NAME, linkInfo)];
    });
  });
}

exports.updateLink = updateLink;

function findOrCreateLink(linkInfo) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , (0, resource_store_1.findOrCreate)(LINK_DETECTION_FIRESTORE_COLLECTION_NAME, linkInfo)];
    });
  });
}

exports.findOrCreateLink = findOrCreateLink;

function createOrUpdateLink(linkInfo) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , (0, resource_store_1.createOrUpdate)(LINK_DETECTION_FIRESTORE_COLLECTION_NAME, linkInfo)];
    });
  });
}

exports.createOrUpdateLink = createOrUpdateLink;

function destroyUrl(url) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , (0, resource_store_1.destroy)(LINK_DETECTION_FIRESTORE_COLLECTION_NAME, url)];
    });
  });
}

exports.destroyUrl = destroyUrl; // mark a link as actually sfw

function markLinkAsClear(url) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , updateLink({
        id: url,
        isCleared: true
      })];
    });
  });
}

exports.markLinkAsClear = markLinkAsClear;

function latestBadLink() {
  return __awaiter(this, void 0, void 0, function () {
    var collection, latestBadLinkQuery, queryResult;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , (0, configure_1.getCollection)(LINK_DETECTION_FIRESTORE_COLLECTION_NAME)];

        case 1:
          collection = _a.sent();
          latestBadLinkQuery = collection;
          badLinkQueries.forEach(function (query) {
            latestBadLinkQuery = latestBadLinkQuery.where(query.field, query.operand, query.value);
          });
          return [4
          /*yield*/
          , latestBadLinkQuery.orderBy('webpurifyHandledTimestampSeconds', 'desc').limit(1).get()];

        case 2:
          queryResult = _a.sent();

          if (queryResult.docs.length === 0) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , queryResult.docs[0].data()];
      }
    });
  });
}

exports.latestBadLink = latestBadLink;